export class Service {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        libelleCourt: { key: 'libelleCourt', optional: true, default: '' }
    };

    id: number;
    code: string;
    libelle: string;
    libelleCourt: string;
}
